export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
// tslint:disable-next-line
export const URL_REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-zA-Z0-9]+([-.]{1}[a-zA-Z0-9\u00C0-\u017F]+)*\.[a-zA-Z0-9]+(:[0-9]+)?(\/.*)?$/;
// tslint:disable-next-line
export const URL_WITH_ATTRIBUTES_REGEX =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(({{[a-zA-Z0-9 ]+}})+|([a-zA-Z0-9]+))([-.]([a-zA-Z0-9\u00C0-\u017F]+|({{[a-zA-Z0-9 ]+}})+)+)*\.(({{[a-zA-Z0-9 ]+}})+|([a-zA-Z0-9]+))+(:[0-9]+)?([\/?].*)?$/;

export const PHONE_MATCH_REGEX = /\+?\(?\d*\)? ?\(?\d+\)?\d*([\s./-]?\d{2,})+/;

export const EMAIL_MATCH_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/;
